import React from 'react';
import { t } from '@lingui/macro';
import { PageBody, PageHeader } from 'components/PageLayout';
import PageHeading from 'components/PageHeading';
import { withErrorBoundary } from 'error';
import { FiltersParams } from 'types/params';
import { ListFilters } from 'components/ListFilters/ListFilters';
const Sfxs: React.FC = () => {
    return (
        <>
            <PageHeader>
                <PageHeading
                    title={t`Browse Sound Effects`}
                    byline={t`Find the best royalty-free sound effects in every category including Voices, Ambience, Industrial, Environment and more.`}
                />
            </PageHeader>
            <PageBody>
                <ListFilters filterParams={FiltersParams.sfxs} />
            </PageBody>
        </>
    );
};

Sfxs.displayName = 'Sfxs';

export default withErrorBoundary(Sfxs, 'page');
